module.exports = __webpack_public_path__ + "img/28.dd9af0e6.png";